import type { AxiosRequestConfigExtended } from '@vision/ui/interfaces';
import type {
  PlannerDashboardsArgs,
  PlannerDashboardDetailArgs,
  PlannerDashboardCreateArgs,
  PlannerDashboardUpdateArgs,
  PlannerDashboardDeleteArgs,
} from './dashboards.api.types';
import { createHttpExtraOptions } from '@vision/ui/utils';

export const buildGetDashboardsRequest = ({
  accountId,
  plannerId,
}: PlannerDashboardsArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/dashboards`,
  method: 'GET',
  params: { account_id: accountId },
});

export const buildGetDashboardByIdRequest = ({
  accountId,
  plannerId,
  dashboardId,
}: PlannerDashboardDetailArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/dashboards/${dashboardId}`,
  method: 'GET',
  params: { account_id: accountId },
});

export const buildCreateDashboardRequest = ({
  accountId,
  plannerId,
  data,
}: PlannerDashboardCreateArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/dashboards`,
  method: 'POST',
  params: { account_id: accountId },
  data,
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.createDashboard.{{status}}',
    },
  }),
});

export const buildUpdateDashboardRequest = ({
  accountId,
  plannerId,
  dashboardId,
  data,
}: PlannerDashboardUpdateArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/dashboards/${dashboardId}`,
  method: 'POST',
  params: { account_id: accountId },
  data,
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.updateDashboard.{{status}}',
    },
  }),
});

export const buildDeleteDashboardRequest = ({
  accountId,
  plannerId,
  dashboardId,
}: PlannerDashboardDeleteArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/dashboards/${dashboardId}/delete`,
  method: 'POST',
  params: { account_id: accountId },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.deleteDashboard.{{status}}',
    },
  }),
});
